// extracted by mini-css-extract-plugin
module.exports = {"lead":"Popular_lead__2ZlIt","filter":"Popular_filter__3KLPS"};